import React, { useMemo } from 'react';
import { useScans } from './useScans';
import { InsightDetectionService } from '../services/insightDetectionService';
import { useAuth } from '../contexts/AuthContext';
export function useWeeklyInsights(userId?: string) {
  const {
    user
  } = useAuth();
  const resolvedUserId = userId || user?.id;
  const {
    scans,
    loading
  } = useScans(resolvedUserId);
  const insights = useMemo(() => {
    if (!scans || scans.length === 0) return null;
    return InsightDetectionService.detectWeeklyInsights(scans);
  }, [scans]);
  return {
    insights,
    loading,
    scans,
    hasInsights: insights && insights.allInsights.length > 0
  };
}